import { css, useTheme } from "@emotion/react"
import {
  breakpoints,
  colorPrimatives,
  fontFamilies,
  fontSizes,
  mediaQueries,
} from "../styles/theme"

const ArticleBody = ({ children }) => (
  <div
    css={css`
      max-width: 700px;
      margin: auto;
      padding-bottom: 32px;

      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 2rem;
      }

      li {
        margin-left: 1em;
        line-height: 1.6em;
      }

      > p:first-of-type::first-letter {
        font-size: 7rem;
        float: left;
        padding-top: 1.5rem;
        padding-right: 1.2rem;
        padding-bottom: 0.25rem;
        line-height: 4rem;
        /* background-color: rgba(0, 0, 0, 0.1); */
      }

      > p:not(:first-of-type) {
        text-indent: 4ch;
        margin-top: 1em;
      }
    `}
  >
    {children}
  </div>
)

export default ArticleBody
